export const load = () => ({
	title: 'Home Soundproofing Overview',
	showTitle: true,
});
